import { render, staticRenderFns } from "./NamingTableVariablesModal.vue?vue&type=template&id=85f8aee8"
import script from "./NamingTableVariablesModal.vue?vue&type=script&lang=js"
export * from "./NamingTableVariablesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports